<div class="image-container">
  <img src="assets/images/gorilla.jpg" alt="Fullscreen image" class="fullscreen-image" />
</div>
